import { Api } from "./Api";

export default {
    getStatsEventsByDrips(params, headers)
    {
        return Api.get(`/v1/statistics/getStatsEventsByDrips?${params}`, {
            headers: headers
        });
    },
    getStatsEventsByDripsPost(obj, headers)
    {
        return Api.post(`/v1/statistics/getStatsEventsByDrips`, obj, {
            headers: headers
        });
    },
    getStatsBySubscribables(params, headers)
    {
        return Api.get(`/v1/statistics/getStatsBySubscribables?${params}`, {
            headers: headers
        });
    },
    getStatsBySubscribablesPost(obj, headers)
    {
        return Api.post(`/v1/statistics/getStatsBySubscribables`, obj, {
            headers: headers
        });
    },
    getStatsPushErrors(params, headers)
    {
        return Api.post(`/v1/statistics/getStatsPushErrors?${params}`, {
            headers: headers
        });
    },
    getStatsPushErrorsPostParams(params, headers)
    {
        return Api.post(`/v1/statistics/getStatsPushErrors`, params, {
            headers: headers
        });
    },
    getTheBestDripRequest(params)
    {
        return Api.get(`/v1/statistics/getTopPush?${params}`);
    },
    getSentLogs(params = "")
    {
        return Api.get(`/v1/statistics/getLogSent?${params}`);
    },
    getCronLogs(params = "")
    {
        return Api.get(`/v1/statistics/getLogCron?${params}`);
    },
    getCSVList()
    {
        return Api.get(`/v1/files/getCSVList`);
    },
    removeFile(basename)
    {
        return Api.get(`/v1/files/removeCSV?filename=${basename}`);
    },
    getDataExplorer({ payload, file = false, cache = 10, params = "" })
    {
        return Api.post(`/v2/statistics/getDataExplorer?file=${file}&cache=${cache}&` + params, payload);
    },
    getServerPerformance({ payload, params = "", file = false, cache = 0 })
    {
        return Api.post(`/v2/statistics/getServerPerformancePage?cache=${cache}&file=${file}${params}`, payload);
    },
    getTopRecurringDripStatistics({ payload, file = false, cache = 10, params = "" })
    {
        return Api.post(`/v2/statistics/getTopClientsByRecurringSentPush?file=${file}&cache=${cache}&` + params, payload);
    },
    getTopRecurringDomainsStatistics({ payload, file = false, cache = 10, params = "" })
    {
        return Api.post(`/v2/statistics/getTopDomainsBySentRecurringPushes?file=${file}&cache=${cache}&` + params, payload);
    },
    getTopWelcomeDripStatistics({ payload, file = false, cache = 10, params = "" })
    {
        return Api.post(`/v2/statistics/getTopClientsByWelcomePushSent?file=${file}&cache=${cache}&` + params, payload);
    },
    getTopWelcomeDomainsStatistics({ payload, file = false, cache = 10, params = "" })
    {
        return Api.post(`/v2/statistics/getTopDomainsBySentWelcomePushes?file=${file}&cache=${cache}&` + params, payload);
    },
    // getTotalSentDrips(params, headers) {
    //     return Api.get(`/v1/statistics/getTotalSentDrips?${params}`, {
    //         headers: {
    //             headers
    //         }
    //     });
    // },
};